'use strict';

/**
 * Publications
 */
waApp.controllers.Publications = {
	_addAndEdit: function() {
		waUtils.inputLanguageToggle();
	},
	add: function() {
		waApp.controllers.Publications._addAndEdit();
	},
	edit: function() {
		waApp.controllers.Publications._addAndEdit();
	}
};
